import React, { useState } from "react";
import { ChevronUp, ChevronDown, Home, Wallet, Backpack, Mail, Bell, Megaphone } from "lucide-react";
import { SAFE_TOP, GLASS, glassBox } from "./ui";

// Slot dock kanan (susunan ala Thaloria, bahasa kaca Jawsel) — fungsi tiap slot mudah diganti/ditambah di sini
export const SIDE_ITEMS = [
  ["rumahku", Home, "Rumahku"],
  ["dompet", Wallet, "Dompet"],
  ["tas", Backpack, "Tas"],
  ["surat", Mail, "Surat"],
  ["kabar", Bell, "Kabar"],
  ["toa", Megaphone, "Toa"],
];

// Dock kanan kaca: pil tembus pandang vertikal berisi tombol bulat; aktif = sentuhan biru tipis (aksen).
// `items` bisa diganti (mis. pintasan di halaman Rumah) — bentuk & gaya tetap sama di semua halaman.
// `badge` = { surat: 3 } → lencana angka merah kecil di ikon (0/false = tidak tampil).
export function SideDock({ active, onOpen, items = SIDE_ITEMS, testid = "kota-dock", prefix = "dock", badge = {} }) {
  const [open, setOpen] = useState(true);
  return (
    <div data-testid={testid} style={{ position: "absolute", right: 10, top: `calc(${SAFE_TOP} + 62px)`, display: "flex", flexDirection: "column", alignItems: "center", gap: 7,
      padding: 5, ...glassBox, borderRadius: 99 }}>
      <button data-testid={`${prefix}-toggle`} aria-label={open ? "Lipat menu" : "Buka menu"} onClick={() => setOpen(o => !o)}
        style={{ width: 28, height: 28, borderRadius: 99, border: 0, background: GLASS.inner, color: GLASS.sub, display: "grid", placeItems: "center", cursor: "pointer", padding: 0 }}>
        {open ? <ChevronUp size={15} /> : <ChevronDown size={15} />}
      </button>
      <div style={{ display: "flex", flexDirection: "column", gap: 7, overflow: "hidden", padding: "4px 4px 0", margin: "-4px -4px 0", maxHeight: open ? 348 : 0, opacity: open ? 1 : 0, visibility: open ? "visible" : "hidden", pointerEvents: open ? "auto" : "none", transition: "max-height .25s ease, opacity .2s ease, visibility .25s" }}>
        {items.map(([key, Icon, label]) => {
          const on = active === key, n = badge[key];
          return (
            <button key={key} data-testid={`${prefix}-${key}`} aria-label={label} title={label} aria-pressed={on} onClick={() => onOpen(on ? null : key)}
              style={{ width: 40, height: 40, borderRadius: 99, border: "1px solid var(--g-border)", background: on ? GLASS.accentBg : GLASS.innerOn, color: on ? GLASS.accent : GLASS.ink, display: "grid", placeItems: "center", cursor: "pointer", padding: 0, position: "relative",
                boxShadow: "0 3px 10px rgba(20,20,20,0.05)", transition: "transform .12s, background-color .3s, color .3s", WebkitTapHighlightColor: "transparent", touchAction: "manipulation" }}
              onPointerDown={e => { e.currentTarget.style.transform = "scale(.92)"; }}
              onPointerUp={e => { e.currentTarget.style.transform = "scale(1)"; }}
              onPointerLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}>
              <Icon size={17} strokeWidth={2} />
              {n > 0 && <span data-testid={`${prefix}-badge-${key}`} style={{ position: "absolute", top: -4, right: -4, minWidth: 16, height: 16, padding: "0 4px", borderRadius: 99, background: "#e11d48", color: "#fff", fontSize: 9.5, fontWeight: 800, display: "grid", placeItems: "center", border: "2px solid var(--g-bg-strong)", boxSizing: "border-box" }}>{n > 99 ? "99+" : n}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
